import Api from 'portal-modules/office-information/api'
import { call, put, takeLatest } from 'redux-saga/effects'
import {
  CHANGE_USER_ACCOUNT,
  LOGOUT,
} from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'

// action types
const REQUEST_OFFICE_INFORMATION = 'rp/property/REQUEST_OFFICE_INFORMATION'
const RECEIVE_OFFICE_INFORMATION = 'rp/property/RECEIVE_OFFICE_INFORMATION'

// action creators
export const requestOfficeInformation = () => ({
  type: REQUEST_OFFICE_INFORMATION,
})

export const receiveOfficeInfromation = payload => ({
  type: RECEIVE_OFFICE_INFORMATION,
  payload,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_OFFICE_INFORMATION:
      return { ...state, ...payload }
    case CHANGE_USER_ACCOUNT:
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// sagas
function* fetchOfficeInformation() {
  const data = yield call(Api.getOfficeInfo)

  yield put(
    addCustomContent({ officeInformation: data.office_hour_custom_text }),
  ),
    yield put(receiveOfficeInfromation(data))
}

function* watchRequestOfficeInformation() {
  yield takeLatest(
    REQUEST_OFFICE_INFORMATION,
    createRequestSaga(fetchOfficeInformation, {
      key: 'officeInformation',
      message: __('Looking up office information'),
    }),
  )
}

export const sagas = [watchRequestOfficeInformation]
